import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Hero from "./components/Hero";
import Schedule from "./components/Schedule";
import Footer from "./components/Footer";
import About from "./components/About";
import JoeziSection from "./components/JoeziSection";
import FaqSection from "./components/FaqSection";
export default function App() {
    return (_jsxs("div", { className: "min-h-screen text-white", children: [_jsx(Hero, {}), _jsx(JoeziSection, {}), _jsx(About, {}), _jsx(Schedule, {}), _jsx(FaqSection, {}), _jsx(Footer, {})] }));
}
